import React, { useLayoutEffect, useRef, useState } from "react";
import { H, W } from "./theme";

// Affiche une slide 1280 × 720 à la largeur disponible, en conservant ses proportions.
// Avec `fit`, elle occupe au mieux la largeur et la hauteur de son parent (`center` la centre aussi en hauteur) ;
// `className` habille alors la slide elle-même, pas la zone qui l'accueille.
const ScaledSlide = ({ children, className = "", fixedWidth, fit, center }) => {
  const ref = useRef(null);
  const [box, setBox] = useState({ width: fixedWidth || 0, height: 0 });

  useLayoutEffect(() => {
    if (fixedWidth || !ref.current) return undefined;
    const element = ref.current;
    const update = () => setBox({ width: element.clientWidth, height: element.clientHeight });
    update();
    if (typeof ResizeObserver === "undefined") return undefined;
    const observer = new ResizeObserver(update);
    observer.observe(element);
    return () => observer.disconnect();
  }, [fixedWidth]);

  const scale = fit && box.height ? Math.min(box.width / W, box.height / H) : box.width / W;
  const inner = box.width > 0 && (
    <div style={{ width: W, height: H, transform: `scale(${scale})`, transformOrigin: "top left", position: "absolute", top: 0, left: 0 }}>
      {children}
    </div>
  );
  if (fit) {
    return (
      <div ref={ref} className={`flex h-full w-full justify-center ${center ? "items-center" : "items-start"}`}>
        <div className={className} style={{ width: W * scale, height: H * scale, position: "relative", overflow: "hidden" }}>
          {inner}
        </div>
      </div>
    );
  }
  return (
    <div ref={ref} className={className} style={{ width: fixedWidth || "100%", height: H * scale, position: "relative", overflow: "hidden" }}>
      {inner}
    </div>
  );
};

export default ScaledSlide;
